import type { ReactNode } from 'react'

export const TableFilterHeader = ({label, children}: {label: string; children?: ReactNode}) => (
  <div className="table-filter-header">
    <span>{label}</span>
    <div className="table-filter-control" onClick={event => event.stopPropagation()}>{children}</div>
  </div>
)
